import React, { createContext, useContext, ReactNode } from "react";

interface InsuranceContextType {
  gd_policy: string;
  gd_benefits: string;
  gd_endorsement: string;
}

const InsuranceContext = createContext<InsuranceContextType | undefined>(undefined);

export const InsuranceProvider: React.FC<{ children: ReactNode; value: InsuranceContextType }> = ({ children, value }) => {
  return (
    <InsuranceContext.Provider value={value}>
      {children}
    </InsuranceContext.Provider>
  );
};

export const useInsurance = () => {
  const context = useContext(InsuranceContext);
  if (!context) {
    throw new Error("useInsurance must be used within an InsuranceProvider");
  }
  return context;
};